export const Methods = {
    GET: 'GET',
    POST: 'POST',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
    UPLOAD: 'POST',
};

export class Requests {
    constructor(defaults = {}) {
        this._interceptors = {
            request: createInterceptors(),
            response: createInterceptors(),
        };
        this._defaults = { headers: {}, ...defaults };
        this._request = createFetchAdapter(this._interceptors);
    }
    onRequest(fulfilled, rejected) {
        return this._interceptors.request.use(fulfilled, rejected);
    }
    onResponse(fulfilled, rejected) {
        return this._interceptors.response.use(fulfilled, rejected);
    }
    _c(config, params = {}) {
        return { ...this._defaults, ...config, ...params };
    }
    request(config = {}) {
        return this._request({ ...config });
    }
    get(url, params = null, config = {}) {
        if (params) {
            url = new URL(window.location.origin + url);
            Object.keys(params).forEach(key =>
                url.searchParams.append(key, params[key])
            );
        }
        return this._request(this._c(config, { method: 'GET', url }));
    }
    post(url, body, config = {}) {
        return this._request(this._c(config, { method: 'POST', url, body }));
    }
    patch(url, body, config = {}) {
        return this._request(this._c(config, { method: 'PATCH', url, body }));
    }
    delete(url, body, config = {}) {
        return this._request(this._c(config, { method: 'DELETE', url, body }));
    }
    upload(url, data, file, config = {}) {
        const body = new FormData();
        for (const name of Object.keys(data)) {
            body.append(name, data[name]);
        }
        body.append('file', file);
        return this._request(this._c(config, { method: 'POST', url, body }));
    }
}

function createInterceptors() {
    const handlers = [];
    return {
        use(fulfilled, rejected) {
            const index = handlers.length;
            handlers.push({
                fulfilled,
                rejected,
            });
            return () => handlers.splice(index, 1);
        },
        forEach(fn) {
            for (let i = 0; i < handlers.length; i += 1) {
                fn(handlers[i]);
            }
        },
    };
}

function createFetchAdapter(interceptors) {
    return config => {
        const handler = config => fetch(`${config.url}`, config);
        const chain = [handler, undefined];
        let promise = Promise.resolve(config);

        interceptors.request.forEach(({ fulfilled, rejected }) =>
            chain.unshift(fulfilled, rejected)
        );
        interceptors.response.forEach(({ fulfilled, rejected }) =>
            chain.push(fulfilled, rejected)
        );
        while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
    };
}
